import { useState } from 'react'
import EquationEditor from "./TextArea"
import axios from "axios";
import Swal from 'sweetalert2'
import { QuestionTypes } from '../constants';
import QuestionIcon from "../assets/multi_choices.jpg";
import { useParams } from 'react-router-dom';
import { BASE_URL } from "../constants";


export default function MultiChoices({
  questions,
  setIsPlaying,
  setQuestions,
  setHitQuestion,
  videoRef,
  editMode = false,
  currentTimeInSec,
  isMutiChoicesVisiable,
  setIsMutiChoicesVisiable,
  question = {
    options:
      [{ optionId: 1, istrue: false, value: "" }, { optionId: 2, istrue: false, value: "" }], questionBody: "", answer: []
  } }) {
  console.log(currentTimeInSec);
  const { id } = useParams();
  const [isCheckboxValid, setIsCheckboxValid] = useState(true);
  const [optionId, setOptionId] = useState(question.options.sort((a, b) => (a.optionId - b.optionId)).at(-1).optionId + 1);
  const [allOptions, setAllOptions] = useState(question.options.sort((a, b) => (a.optionId - b.optionId)));
  const [questionBody, setQuestionBody] = useState(question.questionBody);
  
  const returnOption = () => {
    setAllOptions([...allOptions,
    { optionId: optionId, istrue: false, value: "" }
    ])
    setOptionId(optionId + 1);

  }

  const handleCloseInnerModal = () => {
    setIsMutiChoicesVisiable(!isMutiChoicesVisiable);
  }

  const sweetAlert = ({ title, text, icon }) => {
    return Swal.fire({
      title: `${title}`,
      text: `${text}`,
      icon: `${icon}`
    });
  }

  const updateQuestions = (id, tempOptions = [...allOptions]) => {
    const editedQuestions = questions.filter((q) => q.id !== id).concat([
      {
        id: question.id,
        questionBody: questionBody,
        type: parseInt(QuestionTypes.multiChoices),
        time: Math.floor(currentTimeInSec),
        options: tempOptions.map(option => ({ ...option, istrue: +option.istrue }))
      }])
    setQuestions(editedQuestions);
  }

  const addQuestions = (id, tempOptions = [...allOptions]) => {
    setQuestions((prevQuestions) => [...prevQuestions, {
      id: id,
      questionBody: questionBody,
      type: parseInt(QuestionTypes.multiChoices),
      options: tempOptions.map(option => ({ ...option, istrue: +option.istrue })),
      time: Math.floor(currentTimeInSec)
    }])
  }

  const formatResponse = () => {
    const formattedResponse = {
      question_body: questionBody,
      question_type: parseInt(QuestionTypes.multiChoices),
      options: allOptions.map(option => ({ ...option, istrue: +option.istrue })),
      timestamp: Math.floor(currentTimeInSec)
    }
    if (editMode) {
      updateQuestions(question.id)
    }
    return formattedResponse;
  }

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const atLeastOneChecked = allOptions.some((checkbox) => checkbox.istrue);

    if (!atLeastOneChecked) {
      setIsCheckboxValid(false);
      return;
    }
    const formattedResponse = formatResponse();
    if (editMode) {
      axios.put(`${BASE_URL}/lesson/updateQuestion.php?lessonId=${id}&questionId=${question.id}`, formattedResponse).then((res) => {
        sweetAlert({ title: "Your answer is submitted!", text: "", icon: "info" });
        const video = videoRef.current;
        if (res.data) {
          let tempOptions = [];
          tempOptions = res.data.data?.map((option) => {
            return {
              optionId: option.id,
              istrue: option.istrue,
              option_body: option.option_body,
              value: option.option_body,
              id: option.id
            }
          })
          setAllOptions([...tempOptions])
          updateQuestions(res.data.id, tempOptions)

        }
        handleCloseInnerModal();
        setHitQuestion(false);
        setIsPlaying(true);
        video.id == "video" && video.play();


      })
    } else {
      axios.post(`${BASE_URL}/lesson/addQuestion.php?lessonId=${id}`, formattedResponse).then((res) => {
        sweetAlert({ title: "Your answer is submitted!", text: "", icon: "info" });
        if (res.data.id) {
          let tempOptions = [];
          tempOptions = res.data.final_options?.map((option) => {
            return {
              optionId: option.id,
              istrue: option.istrue,
              option_body: option.option_body,
              value: option.option_body,
              id: option.id
            }
          })
          setAllOptions([...tempOptions])
          addQuestions(res.data.id, tempOptions)

        }
        handleCloseInnerModal();
      })
    }
  };

  const handleDeleteOption = (event, optionId) => {
    event.preventDefault()
    setAllOptions(allOptions.filter((option) => (option.optionId !== optionId)));

  }

  const handleCheckboxChange = (event, optionId) => {
    const updatedCheckboxes = allOptions.map((checkbox) => {
      if (checkbox.optionId == optionId) {
        return { ...checkbox, istrue: event.target.checked };
      }
      return checkbox;
    });
    setAllOptions(updatedCheckboxes);
    setIsCheckboxValid(true);
  }

  const handleOptionInput = (event, optionId) => {
    const updatedOptionsValue = allOptions.map((optionValue) => {
      if (optionValue.optionId == optionId) {
        return { ...optionValue, value: event.target.value };
      }
      return optionValue;
    });
    setAllOptions(updatedOptionsValue);
  }

  return (
    <form onSubmit={handleFormSubmit} className='question-overlay rounded-lg'>

      <div className="flex items-center font-semibold text-xl gap-2 mb-2">
        <img src={QuestionIcon} alt="Icon" />
        <p className='m-0'>Multichoices Question</p>
      </div>

      <div className="flex flex-col gap-4">
        <EquationEditor questionBody={questionBody} setQuestionBody={setQuestionBody} />

        <div className='flex flex-col gap-2'>
          {allOptions.map((option, idx) => (
            <div className="input-group" key={idx}>
              <span className="input-group-text">
                <span className='check-box'>
                  <input
                    checked={option.istrue == 1} type="checkbox" className="form-check-input" id={`option${option.optionId}`}
                    onChange={(event) => handleCheckboxChange(event, option.optionId)}
                    value={option.value}
                  />
                </span>
              </span>

              <input
                required type="text"
                id={`value${option.optionId}`}
                onChange={(event) => handleOptionInput(event, option.optionId)}
                value={option.value}
                className="form-control rounded-r"
                placeholder="Answer option"
              />

              {allOptions.length > 2 &&
                <button
                  onClick={(event) => handleDeleteOption(event, option.optionId)}
                  className='trash-icon'>
                  <i className="fa-solid fa-trash"></i>
                </button>
              }
            </div>
          ))}
          {!isCheckboxValid && (
            <div className="text-danger">Please select at least one checkbox.</div>
          )}

        </div>

      </div>


      <div className='flex justify-between mt-4'>
        <button onClick={returnOption} type="button" className="btn btn-primary">+ Add Answer</button>

        <div className='flex gap-2'>
          <button onClick={handleCloseInnerModal} type="button" className="btn btn-secondary">Cancel</button>
          <button onClick={handleFormSubmit} type="submit" className="btn btn-primary active">Save</button>
        </div>

      </div>
    </form>
  )
}
